import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RouterOutlet } from '@angular/router';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { StorageService } from './common/services/storage.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NzModalModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'base-web';

  private storage = inject(StorageService);
  private router = inject(Router);
  private modal = inject(NzModalService);

  private sessionChecked = false;

  ngOnInit(): void {
    this.checkSession();

    setInterval(() => {
      this.checkSession();
    }, 60_000);
  }

  private checkSession(): void {
    const token = this.storage.token;

    if (!token) return;

    if (this.storage.isSessionExpired && !this.sessionChecked) {
      this.sessionChecked = true;

      this.storage.logout();

      this.modal.confirm({
        nzTitle: 'Sesión expirada',
        nzContent: 'Tu sesión ha expirado por inactividad. Podés iniciar sesión nuevamente o continuar navegando sin estar autenticado.',
        nzOkText: 'Iniciar sesión',
        nzCancelText: 'Cerrar',
        nzClosable: false,
        nzMaskClosable: false,
        nzOnOk: () => {
          this.router.navigate(['/auth/login']);
          this.sessionChecked = false;
        },
        nzOnCancel: () => {
          this.sessionChecked = false;
        }
      });

    }
  }
}
